import { useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { SectionLoader } from "../../shared/SectionLoader";

export function Callback() {
  const { idToken, logOut, loginInProgress, error: loginError } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (idToken) {
      const redirectPath = localStorage.getItem("postLoginRedirect");
      if (redirectPath) {
        localStorage.removeItem("postLoginRedirect");
        navigate(redirectPath);
      } else {
        navigate("/");
      }
    } else if (!loginInProgress && loginError) {
      // Show error + full session clear + force re-login
      window.dispatchEvent(
        new CustomEvent("show-error", {
          detail: "You are not authorized to login into this application.",
        })
      );
      setTimeout(() => {
        logOut(); // will redirect to Cognito login
      }, 1500);
    } else if (!loginInProgress && !idToken) {
      navigate("/auth");
    }
  }, [idToken, loginInProgress, loginError, navigate, logOut]);

  if (loginInProgress) {
    return <SectionLoader message="Loading, please wait..." />;
  }

  if (!idToken && loginError) {
    return <SectionLoader message="You are not authorized. Redirecting..." />;
  }

  return <div>{idToken ? "Successfully logged in." : "Not logged in."}</div>;
}
